module.exports = __webpack_public_path__ + "static/chat-616561a31ad72f4205a889b4a0860aab.png";